export type AgentStatus = "in_progress" | "under_review" | "completed" | "rejected";

export enum MainCategory {
  HORIZONTAL = "horizontal",
  VERTICAL = "vertical",
  ENABLER = "enabler",
}
export interface Agent {
  id: string;
  owner_id: string;
  name: string;
  provider: string | null;
  short_description: string | null;
  solution: string | null;
  categories: string;
  application_area: string | null;
  status: AgentStatus;
  embedding_status: string;
  editable: boolean;
  created_at: string;
  updated_at: string | null;
  selected_count: number;
  main_category: MainCategory;
}

export interface AgentListItem {
  id: string;
  name: string;
  short_description: string | null;
  provider: string | null;
  categories: string;
  selected_count: number;
  created_at: string;
  updated_at: string | null;
}

export interface AgentDetail extends Agent {}

export interface PublicAgentDetail {
  id: string;
  name: string;
  provider: string | null;
  short_description: string | null;
  solution: string | null;
  categories: string | null;
  application_area: string | null;
  main_category?: string | null;
  selected_count: number;
  created_at: string;
  updated_at: string | null;
}
